import GymRatingBsquatRepository from '@/shared/http/repositories/socialProject/gymRating-bsquat'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading } from '@/shared/utils/UIHelper'
import VueHighcharts from 'vue2-highcharts'

export default {
  components: {
      VueHighcharts
  },

  props: {
    items: {
      type: Object,
      default: {}
    }
  },

  data: () => ({
    options: {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Rendimento da Turma'
      },
      subtitle: {
        text: 'Média de Bsquat'
      },
      xAxis: {
        type: 'category',
        labels: {
            rotation: -45,
            style: {
                color: '#0d75a3',
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif'
            }
        }
      },
      yAxis: {
        min: 0,
        title: {
            text: 'Médias'
        }
      },
      legend: {
        enabled: false
      },
      tooltip: {
        pointFormat: 'Média dê: <b>{point.y:.1f} (Bsquat)</b>'
      },
      series: [{
        name: 'Médias',
        dataLabels: {
            enabled: true,
            rotation: -90,
            color: '#FFFFFF',
            align: 'right',
            format: '{point.y:.1f}', // one decimal
            y: 10, // 10 pixels down from the top
            style: {
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif',
            }
        }
      }]
    }
  }),

  watch: {
    items: {
      handler: function (value) {
        if (value.id) {
          this.loadChargeData(value.id)
        }
      },
      immediate: true
    }
  },

  methods: {
    loadChargeData(id) {
      loading.push()
      GymRatingBsquatRepository.GetGymRatingBsquatByGymRatingId(id)
      .then(response => {

        if(!IsSuccessCode){
          return Promise.reject()
        }

        const student = response.data.data

        let studentFeminineName = []
        let studentFeminine = []
        let orderDescByBsquat = []
        let studentAverage = []
        let classAverage = 0
        
        if (student.length != 0) {
          studentFeminine = student.filter(sn => sn.bsquat != null).filter(sn => sn.studentGender == 'Feminino')
          orderDescByBsquat = studentFeminine.sort(function(a,b) {return b.bsquat - a.bsquat;})
          studentFeminineName = orderDescByBsquat.map(sn => sn.studentName)
          studentAverage = orderDescByBsquat.map(sn => sn.bsquat)
          classAverage = studentAverage.reduce((value1, value2) => value1 + value2, 0) / studentAverage.length
          this.$emit('classAverageFeminine', Number(parseFloat(classAverage).toFixed(1)))
          
          studentFeminineName.push('MÉDIA DA TURMA')
          studentAverage.push(classAverage)

          studentFeminineName.push('LITERATURA')
          studentAverage.push(this.items.feminineBsquatLiterature * 100)
        }

        setTimeout(() => {
          this.$refs.lineCharts.chart.update({
            xAxis: {
              categories: studentFeminineName,
              text: null
            },
            series: [{
              name: 'Média',
              data: studentAverage
            }],
            title: {
              text: 'Rendimento da Turma',
              align: 'center'
            },
            subtitle: {
              text: 'Média de Bsquat',
              align: 'center'
            }
          })

          loading.pop()
        }, 1300)
      })
      .catch(e => {
        loading.pop()
        console.log(`Erro ao tentar obter os dados para o gráfico de rendimentos da turma: \n ${e}`)
      })
    }
  }
}